import React from 'react';
import PropTypes from 'prop-types';
import { getBadge } from '../../../helper/get_badge';
import Translation from '../../translation/translation';

function ProductBadge({ product, isRecommended }) {
  const badge = getBadge(product);

  if (!badge) {
    return null;
  }

  return (
    <>
      <div className="product-tile__product-badge">{badge}</div>
      {product.isNewProduct && (
        <Translation
          tagName="div"
          translationKey={'badge-ribbon-new'}
          className="ribbon-badge"
          style={isRecommended ? { right: '0' } : {}}
        />
      )}
    </>
  );
}

ProductBadge.propTypes = {
  product: PropTypes.object.isRequired,
};

export { ProductBadge };
